import { Link } from 'gatsby';
import Img from 'gatsby-image';
import _ from 'lodash';
import React from 'react';
import { PageContext } from '../../templates/tools/resources';
export interface PostCardProps {
  post: PageContext;
  large?: boolean;
}

export const WorkOnFirst: React.FC<PostCardProps> = ({ post, large = false }) => {

  return (

    <>
    
      <div className="col-lg-2  my-4">
        <div className="card shadow-sm">
          <div className="d-flex align-items-center">
            <div className="img-wrapper col-12 p-0  position-relative image-overlap-shadow">
              {post.frontmatter.image && (
                <Link to={post.fields.slug}>
                  {post.frontmatter?.image?.childImageSharp?.fluid && (
                    <Img
                      alt={`${post.frontmatter.title} cover image`}
                      style={{ height: '100%' }}
                      fluid={post.frontmatter.image.childImageSharp.fluid}
                    className='zoom-on-hover'
                    />
                  )}
                </Link>
              )}
            </div>
          </div>
      
        </div>
      </div>
     
    </>

  );
};
